import { Progress, Tooltip } from 'antd';

import { useWindowWidth } from 'hooks';
import { compactNumber } from 'utils/number';

import { StatTitle } from './styled';

const Stat = ({ label, value: rawValue, color, total, onClick }) => {
  // Cap the displayed match count at the SQL-precomputed total — the
  // ResearchersMatched / etc. cardinality is HLL-estimated and can overshoot.
  const value = total > 0 ? Math.min(rawValue, total) : rawValue;
  const percent = total ? (value / total) * 100 : 0;
  const { isMobile, isSmallLaptop } = useWindowWidth();
  const fadedColour = color.replace('0.5', '0.1');

  const formattedValue = compactNumber(value);
  const formattedTotal = compactNumber(total);

  const size = isMobile ? 45 : isSmallLaptop ? 45 : 60;
  const padding = isMobile ? '0 5px' : isSmallLaptop ? '0 10px' : '0 15px';
  const fontSize = isSmallLaptop ? 14 : 18;

  let title = total
    ? `${formattedValue} matched out of ${formattedTotal} total`
    : `${formattedValue} matched`;

  return (
    <Tooltip title={title}>
      <div
        onClick={onClick}
        style={{
          display: 'flex',
          alignItems: 'center',
          flexDirection: 'column',
          cursor: onClick ? 'pointer' : 'default',
        }}
      >
        <Progress
          format={() => (
            <div style={{ fontSize, fontWeight: 500 }}>{formattedValue}</div>
          )}
          trailColor={total > 0 ? fadedColour : null}
          type='circle'
          width={size}
          percent={percent}
          strokeColor={color}
          style={{ padding }}
          status='normal'
        />
        <StatTitle>{label}</StatTitle>
      </div>
    </Tooltip>
  );
};

export default Stat;
